'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('content-slider-editor', {
      url: '/admin/content-slider-editor',
      template: '<content-slider-editor></content-slider-editor>',
      authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/admin/content-slider/content-slider-editor.routes.js